// extracted by mini-css-extract-plugin
export default {"container":"Eq-z","brandName":"Fq-z","productName":"Gq-z","productNamePdpEnhancements":"Hq-z","breakLongProductName":"Iq-z"};